/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';

interface AttributeAutocompleteArgs {
  selectedAttribute?: string;
  error?: string;
  disabled?: boolean;
  size?: string;
  placeholder?: string;
  searchPlaceholder?: string;
  itemWidth?: string;
  allowClear?: boolean;
  allowCustomValues?: boolean;
  widthModifier?: string;
  matchTriggerWidth?: boolean;
  renderInPlace?: boolean;
  searchEnabled?: boolean;
  onChange: (newAttribute: string | null | undefined) => unknown;
  isObject?: boolean;
  verticalPosition?: 'auto' | 'above' | 'below';
  hideAttributeLabel?: boolean;
}

export default class AttributeAutocomplete extends Component<AttributeAutocompleteArgs> {
  get matchTriggerWidth() {
    return this.args.matchTriggerWidth ?? true;
  }

  get searchEnabled() {
    return this.args.searchEnabled ?? true;
  }

  get searchPlaceholder() {
    return this.args.searchPlaceholder ?? 'Find or specify an attribute…';
  }

  get allowCustomValues() {
    return this.args.allowCustomValues ?? true;
  }

  get renderInPlace() {
    return this.args.renderInPlace ?? true;
  }

  get verticalPosition() {
    return this.args.verticalPosition ?? 'auto';
  }

  @action
  onChange(selection: string | Record<string, any> | null) {
    // The selection can either be:
    // - null (when clearing the input)
    // - a string (when selecting an option in the dropdown)
    // - an object (when selecting a custom value)
    if (!selection || typeof selection === 'string') {
      return this.args.onChange(selection);
    }

    return this.args.onChange(selection.value);
  }
}
